module.exports = __webpack_public_path__ + "static/media/compbanner.d24f08f6.jpg";